/*
 * @Author: Json Chen
 * @Date: 2021-07-28 13:24:23
 * @LastEditTime: 2023-02-01 13:27:13
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLocalisation/Components/AreaCodes.tsx
 */

import { Filter } from '@/src/components';
import { Button, Modal } from '@/src/components/Antd';
import DeletePopconfirm from '@/src/components/DeletePopconfirm/DeletePopconfirm';
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { areaCodesSearch } from '@/src/request/salesChannel/setting/areaCodes';
import { useRequest } from 'ahooks';
import { Checkbox, ConfigProvider, Spin } from 'antd';
import { get } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { SectionContainer } from 'src/components/Layouts';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../style.module.less';
import AreaCodeModalForm from './AreaCodeModalForm';
import ManualValidation from './ManualValidation';
import css from './css.module.less';

// 最大勾选数量
const MAX_CHECKABLE_LENGTH = 10;

const AreaCodes = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    modalOp, //: { setShowModal, setModalTitle, setModalContent },
    value,
    onChange,
    hasError,
    disableEdit,
  } = props;

  const { setShowModal: sS, setModalTitle: sT, setModalContent: sC } = modalOp;
  const [visiable, setVisiable] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>();
  const [modalContent, setModalContent] = useState<any>();
  const [_searchValue, _setSearchValue] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [areaCodes, setAreaCodes] = useState([]);
  const showModal = () => {
    setVisiable(true);
  };

  const hideModal = () => {
    setVisiable(false);
  };

  const onModalConfirm = (chooseList) => {
    onChange(
      chooseList.map((item) => {
        const same = (value || []).find(
          (v) => v.areaCodeInfo.uuid === item.uuid,
        );
        return (
          same || {
            areaCode: item.areaCode,
            countryCode: item.code,
            stickToTop: false,
            uuid: item.uuid,
            areaCodeInfo: item,
          }
        );
      }),
    );
  };

  const onSelectClick = () => {
    // setVisiable(false);
    setModalTitle(getI18n('salesChannelLocalisation.index.selectAreaCode'));

    setModalContent(
      <AreaCodeModalForm
        onCancel={hideModal}
        onModalConfirm={onModalConfirm}
        existList={value || []}
        areaCodes={areaCodes}
      />,
    );

    showModal();
  };

  const onSearchChange = (v) => {
    _setSearchValue(v);
  };

  const onTableChange = (sortVal) => {
    onChange(
      sortVal.map((item) => ({
        areaCode: item.areaCode,
        countryCode: item.code,
        stickToTop: item.stickToTop,
        uuid: item.uuid,
        manualValidation: item.manualValidation,
        areaCodeInfo: item,
      })),
    );
  };

  const onDelete = (item) => {
    let newValue;
    if (item) {
      newValue = value.filter((v) => v.areaCodeInfo?.uuid !== item.uuid);
    } else {
      newValue = [];
    }
    onChange(newValue);
  };

  const onCheckChange = (checked, record) => {
    //TODO:  这里 value 的值没有uuid,导致的下面的问题
    const newValue = value
      .map((item) =>
        item.areaCodeInfo?.uuid === record.uuid
          ? {
              ...item,
              stickToTop: checked,
            }
          : item,
      )
      .sort((a, b) => {
        if (a.stickToTop && b.stickToTop) return 0;
        if (a.stickToTop && !b.stickToTop) return -1;
        return 1;
      });
    onChange(newValue);
  };

  const onValidationChange = (manualValidation, record) => {
    onChange(
      value.map((item) =>
        item.areaCodeInfo?.uuid === record.uuid
          ? {
              ...item,
              manualPhoneValidation: manualValidation,
            }
          : item,
      ),
      // .sort((a, b) => {
      //   if (a.stickToTop && b.stickToTop) return 0;
      //   if (a.stickToTop && !b.stickToTop) return -1;
      //   return 1;
      // }),
    );
  };

  const calcRowClassName = (record) => {
    return record._show ? styles.show : styles.hide;
  };

  const { loading: areaCodesSearchLoading, run: _areaCodesSearch } = useRequest(
    (searchText = '') => areaCodesSearch({ searchText }),
    {
      manual: true,
      onSuccess(result) {
        setAreaCodes(result);
      },
    },
  );

  const list = useMemo(() => {
    const v = searchValue.trim().toLowerCase();
    return (value || [])
      .map((item) => {
        const same = areaCodes.find((a) => a.code === item.countryCode);
        const show = v
          ? same.areaCode.toLowerCase().includes(v) ||
            same.name.toLowerCase().includes(v) ||
            same.code.toLowerCase().includes(v)
          : true;
        return {
          ...same,
          ...item,
          hideDragHandler: !item.stickToTop,
          _show: show,
        };
      })
      .sort((a, b) => {
        if (!areaCodes.length) {
          return 0;
        }
        if (a && b && !a.stickToTop && !b.stickToTop) {
          return a.name[0].charCodeAt() - b.name[0].charCodeAt();
        }
        if (a.stickToTop && b.stickToTop) {
          return 0;
        }

        if (a.stickToTop && !b.stickToTop) {
          return -1;
        }
        if (!a.stickToTop && b.stickToTop) {
          return 1;
        }
      });
  }, [searchValue, value, areaCodes]);
  const noResult = useMemo(() => {
    return (
      !!searchValue.trim() &&
      (list || []).every((i) => !i._show) &&
      !!(value || []).length
    );
  }, [searchValue, list, value]);
  const checkedLength = useMemo(() => {
    return (value || []).filter((v) => v.stickToTop).length;
  }, [value]);

  const columns = [
    {
      title: getI18n('salesChannelLocalisation.index.phoneNumberRegionCodes'),
      dataIndex: 'code',
      default: true,
      minWidth: 320,
      render: (text, record) => {
        return (
          <div className={styles.phoneNumberareaCode}>
            {record.name} (+{record.areaCode})
          </div>
        );
      },
    },
    {
      title: (
        <span>
          <EditIcon />
          {getI18n('salesChannelLocalisation.index.manualValidation')}
        </span>
      ),
      dataIndex: 'code',
      default: true,
      minWidth: 320,
      render: (text, record) => {
        const manualValidation = get(record, 'manualPhoneValidation');
        const areaCode = `${get(record, 'name')} +${record.areaCode}`;
        const enabled = get(manualValidation, 'enabled');
        const includeZero = get(manualValidation, 'includeZero');
        const digits = get(manualValidation, 'digits');
        const getT = () => {
          if (!enabled) {
            return getI18n('salesChannelLocalisation.index.addRequirment');
          } else {
            if (includeZero) {
              return `${digits}, ${getI18n(
                'salesChannelLocalisation.index.includeprefix0',
              )}`;
            } else {
              return `${digits}, ${getI18n(
                'salesChannelLocalisation.index.excludeprefix0',
              )}`;
            }
          }
        };
        return (
          <div
            className={css.validationText}
            onClick={() => {
              sT(getI18n('salesChannelLocalisation.index.addManualValidation'));
              sC(
                <ManualValidation
                  value={manualValidation}
                  areaCode={areaCode}
                  onChange={(e) => {
                    onValidationChange(e, record);
                    sS(false);
                  }}
                  onCancel={() => {
                    sS(false);
                  }}
                />,
              );
              sS(true);
            }}>
            {getT()}
          </div>
        );
      },
    },
    {
      title: getI18n('salesChannelLocalisation.index.sticktothetop'),
      default: true,
      dataIndex: 'code',
      align: 'center',
      minWidth: 460,
      childGenerate: (text, record) => {
        return (
          <div className={styles.center}>
            <Checkbox
              disabled={
                (record.stickToTop
                  ? false
                  : checkedLength === MAX_CHECKABLE_LENGTH) || disableEdit
              }
              checked={record.stickToTop}
              onChange={(e) => onCheckChange(e.target.checked, record)}
            />
          </div>
        );
      },
    },
    disableEdit
      ? {}
      : {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          default: true,
          optional: true,
          align: 'center',
          minWidth: 256,
          childGenerate: (_, record) => {
            return (
              <div className={`${styles.action} ${styles.center}`}>
                <DeletePopconfirm
                  title={getI18n(
                    'salesChannelLocalisation.index.deletePopconfirmTitle',
                  )}
                  confirm={() => onDelete(record)}
                  btnClassName={styles.delButton}
                  getPopupContainer={() => document.body}
                  size='large'>
                  <span className={styles.danger}>
                    {getI18n('general.delete')}
                  </span>
                </DeletePopconfirm>
              </div>
            );
          },
        },
  ];

  useEffect(() => {
    _areaCodesSearch();
  }, []);
  return (
    <div className={styles.phoneNumberRegionCode}>
      <Spin spinning={areaCodesSearchLoading}>
        <SectionContainer bottomBorder className={css.section}>
          <ItemWrapper
            title={getI18n(
              'salesChannelLocalisation.index.phoneNumberAreaCodes',
            )}
            titleContainerClassName={css.areaCodeTitle}>
            <Filter
              className={styles.areaCodesSearch}
              searchClassName={styles.areaCodesSearchInput}
              searchValue={_searchValue}
              searchOnchange={onSearchChange}
              pressEnter={(e) => setSearchValue(e.target.value)}
              onSearch={setSearchValue}
            />
            {hasError ? (
              <div className={styles.errText}>
                {getI18n('salesChannelLocalisation.index.filterHasError')}
              </div>
            ) : null}
            {noResult ? (
              <div>
                {getI18n('salesChannelLocalisation.index.noSearchResult')}
              </div>
            ) : (
              <div className={styles.phoneNumberRegionCodeTable}>
                <ConfigProvider
                  renderEmpty={() => (
                    <div className={styles.noPhoneNumberareaCode}>
                      {getI18n(
                        'salesChannelLocalisation.index.pleaseselectareacode',
                      )}
                    </div>
                  )}>
                  <DroppableTable
                    scroll={{ y: '600px' }}
                    id='SalesChannelLocalisationAreaCodes'
                    rowKey={'countryCode'}
                    className={styles.dragAbleTable}
                    rowClassName={calcRowClassName}
                    columns={columns}
                    dataSource={list}
                    pagination={false}
                    onTableChange={onTableChange}
                    hideAllDragHandlers={disableEdit}
                  />
                </ConfigProvider>
              </div>
            )}
            <div>
              <Button
                type='primary'
                onClick={onSelectClick}
                disabled={disableEdit}>
                {getI18n('salesChannelLocalisation.index.selectAreaCode')}
              </Button>

              <DeletePopconfirm
                title={getI18n('salesChannelLocalisation.index.deleteTitle')}
                confirm={onDelete}
                btnClassName={styles.delButton}
                size='large'>
                <Button
                  danger
                  className={styles.dangerButton}
                  disabled={disableEdit}>
                  {getI18n('salesChannelLocalisation.index.deleteAll')}
                </Button>
              </DeletePopconfirm>
            </div>
          </ItemWrapper>
        </SectionContainer>
      </Spin>
      <Modal
        className={`${styles.areaCodeModal} ${styles.areaCodeModalWrap}`}
        width={600}
        visible={visiable}
        onCancel={hideModal}
        title={modalTitle}>
        {modalContent}
      </Modal>
    </div>
  );
};
export default ModalHoc(AreaCodes);
